<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<router-link to="/account/index" class="back-btn"><span></span>注销账号</router-link>
	</div>
	<div class="ld-panel-main">
		<el-steps :active="0" finish-status="success" simple style="margin-bottom: 30px;">
		    <el-step title="协议与反馈" />
		    <el-step title="账号信息检查" />
		</el-steps>
		<el-alert title="温馨提示：注销前请您仔细阅读以下重要信息！提交账号注销申请为不可逆操作!" type="warning" show-icon :closable="false" />
		<el-card class="box-card">
		    <template #header>
		      <div class="card-header">
		        <span>为保证您的账号、财产安全，并保障正常的社会公共秩序，在您提交蓝队云账号注销请求前，请先确认如下信息：</span>
		      </div>
		    </template>
		    <ul class="main">
		      <li>1、提交账号注销请求的为您本人，或获得账号持有者本人合法授权的代理人/代表人。后一种情形下，代理人/代表人需将本提示及注销过程中的所有文件，告知账号持有者本人并确保本人已理解并同意前述文件的全部内容。</li>
		      <li>2、您申请注销的账号处于稳定且安全的状态（例如：未发生过被盗、被封等风险，在最近三个月内没有进行修改密码、换绑手机等敏感信息变更的操作等）</li>
		      <li>3、您是通过常用的安全设备向我方提交账号注销申请；</li>
		      <li>4、您的账号下不存在尚未履行完毕的合同，亦不存在任何未结清的费用、未缴纳的税款，或其他依照法律法规的要求应当履行而尚未履行的义务；</li>
		      <li>5、您的账号与其他第三方网络应用（例如：网站、APP）的绑定关系或对外授权已经解除，或者您能确信不解除该等绑定关系或不撤回该等对外授权不会对您本人或任何第三方造成任何不利影响；</li>
		      <li>6、您在蓝队云账号下的所有数据均已迁出及妥善备份，或您完全放弃保留、找回该等数据的权利；</li>
		      <li>7、您提交账号注销申请，并非为了躲避正在或即将发生的纠纷诉讼，或规避主管部门的监管，或绕开法律法规的相关规定等不良意图。</li>
		    </ul>
		</el-card>
		<div class="foot-warn" style="margin: 30px 0 20px;">
			<h4 class="title">温馨提示：</h4>
			<div class="content">
				<p>1、提交账号注销申请为不可逆操作</p>
				<p>2、账号注销后，您将无法再次登录蓝队云网站、论坛、APP，无法访问控制面板或云站点控制面板或进行其他依赖于账号权限进行的操作。</p>
			    <p>3、您在该账号下的个人信息、交易记录、业务数据、历史信息等均将无法找回。</p>
			    <p>4、如果您希望保持与此账号相关联的任何云服务（包括云站点），仅希望终止部分产品/资源，请不要继续后续操作。</p>
			</div>
		</div>
		<el-alert title="您正在尝试注销自己的蓝队云帐号。请确保账号下无有效业务，在账号注销期间不要进行任何操作，以免注销失败。注销后，您将无法再使用任何蓝队云服务，并且您的帐号和数据也将会丢失。" type="error" :closable="false" />
		<div class="agree">
			<el-switch v-model="checked" style="float: left; margin: -5px 5px 0 0; " @change="agreeChange" />
			<span class="tip">我已阅读并同意<a :href="domain+'/agreement/account.html'" target="_blank">《蓝队云账号注销协议》</a>，提交申请后，我的账号 将被注销，包含的内容、数据和服务都不可再恢复</span>
		</div>
		<el-button type="primary" :disabled=disabled @click="submitForm">下一步</el-button>
	</div>
</template>


<script setup>
	import { ref,reactive,inject,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import sideNav from '../../components/sideNav.vue';
	
	const pageTitle = 'account';
	const router = useRouter();
	const domain = inject('domain');
	const disabled = ref(true);
	const checked = ref(false);
	const agreeChange = (val) =>{
		if(val){
			disabled.value = false
		}else{
			disabled.value = true
		}
	}
	const submitForm = () => {
		router.push({ path: '/account/delCheck' })
	};
	
</script>

<style lang="scss" scoped>
	.main{
		li{color: #666; line-height: 22px; margin: 6px 0;}
	}
	.agree{ margin: 20px 0; overflow: hidden;}
</style>